import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { ISector, PendingCounterApiResponse } from '../models';
import { GlobalButton } from '@/components';
import { Sector } from './Sector';

interface SectorListProps {
  sectors: PendingCounterApiResponse[];
  selectedSector: ISector | null;
  onSelectSector: (sector: PendingCounterApiResponse) => void;
  onToggleLock: (sector: PendingCounterApiResponse) => void;
  onCallNext?: () => void;
  isLoadingCallNext?: boolean;
  sectorName?: string;
}

export const SectorList = ({
  sectors,
  selectedSector,
  onSelectSector,
  onToggleLock,
  onCallNext,
  isLoadingCallNext,
  sectorName,
}: SectorListProps) => {
  return (
    <div className='flex justify-between items-center'>
      <div className='flex gap-8 items-center'>
        {sectors?.map((sector) => (
          <Sector
            key={sector.sectorId}
            sector={sector}
            selectedSector={selectedSector}
            onLock={() => onToggleLock(sector)}
            onSelect={() => onSelectSector(sector)}
          />
        ))}
      </div>

      {onCallNext && (
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={onCallNext}
          disabled={isLoadingCallNext}
        >
          <NotificationsIcon />
          {sectorName} - Llamar siguiente
        </GlobalButton>
      )}
    </div>
  );
};
